export enum WORKFLOW_TEXT_CONSTANTS {
	DELETE_TITLE = 'Confirm Delete',
	DELETE_SUB_TITLE = 'This action cannot be undone and you wll not be able to recover this Data.',
	DELETE_CONFIRMATION = 'Are you sure you want to delete the ',
	DELETE_BUTTON_CANCEL_LABEL = 'Cancel',
	DELETE_BUTTON_LABEL = 'Delete',
	WORKFLOW_STEP_DELETED = 'Workflow Step Deleted Successfully.',
	QUEUE_CREATED = 'Queue Created Successfully.',
	QUEUE_UPDATED = 'Queue Updated Successfully.',
	QUEUE_DELETED = 'Queue Deleted Successfully.',
	ADD_USERS = 'Add Users',
	CREATE = 'create',
	EDIT = 'edit',
	CREATE_WORKFLOW_TITLE = 'Please indicate a workflow step and assign it to a queue and/or individual.',
	CREATE_WORKFLOW_LABEL = 'Add Workflow Step',
	CREATE_WORKFLOW_ASSIGNEE_LABEL = 'Assignee',
	WORKFLOW_STEP_CREATED = 'The addition of the workflow step was successfully.',
	WORKFLOW_STEP_UPDATED = 'Workflow Step Updated Successfully.',
	ADD_QUEUES = 'Add Queues',
}
